module.exports = __webpack_public_path__ + "img/gamma.bbc05f23.png";